import { FC } from 'react';
import { Action, Label, TableBody, TableHeader, TableRow } from '../../atoms';
import { Table } from '../../molecules';
import cn from 'classnames';
import { getRoleSeparation } from '../../../utils/Helpers/role-helper';
import { UserRoleDto } from '../../../store/contextAPI/role/dto/response/user-role.dto';
import styles from './UserManagementUsersRoles.module.css';

interface UserManagementUsersRolesOrganismProps {
  data: UserRoleDto[];
  handleDeleteRole: (id: string) => void;
}

const UserManagementUsersRolesOrganism: FC<
  UserManagementUsersRolesOrganismProps
> = ({ data, handleDeleteRole }) => {
  return (
    <>
      {data.length === 0 ? (
        <Label size={'heading-md'} content={'User has no assigned roles'} />
      ) : (
        <Table>
          <div className={cn(styles.hidden)}>
            <TableHeader>
              <TableRow header={true}>
                <Label content="Role Name" />
                <Label />
              </TableRow>
            </TableHeader>
          </div>
          <TableBody>
            {data.map((row: UserRoleDto) => (
              <TableRow key={`${row.id}-${row.roleId}`}>
                {row?.roleName && (
                  <Label content={getRoleSeparation(row.roleName)}></Label>
                )}
                <Label content={row?.proflieName ?? ''}></Label>
                <div className={cn(styles.deleteCell)}>
                  {row.roleName !== 'RegisteredUser' && (
                    <Action
                      type="delete"
                      size="sm"
                      onClick={() => handleDeleteRole(row.id)}
                    />
                  )}
                </div>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </>
  );
};

export default UserManagementUsersRolesOrganism;
